'use client'

import React from 'react'
import { NewsList } from '@/components/newt/templates/NewsList'
import { Intro } from '@/components/parts/intro/Intro'
import { Contact } from '@/components/parts/contact'
import type { News } from '@/types/newt/news'
import dynamic from 'next/dynamic'

const Pagination = dynamic(
  () => import('../parts/Pagination').then((mod) => mod.Pagination),
  {
    ssr: false
  }
)

type NewsPageProps = {
  news: News[]
  total: number
}

export function NewsPage({ news, total }: NewsPageProps) {
  return (
    <>
      <Intro title="お知らせ" lead="LAWGUEからのお知らせです" />
      <section className="px-6">
        <div className="mx-auto py-16 lg:py-20 text-center lg:max-w-[1200px]">
          {news.map((news) => (
            <NewsList key={news._id} news={news} />
          ))}
          <Pagination
            total={total}
            current={1}
            basePath={'/news/page'}
            contentType="news"
          />
        </div>
      </section>
      <Contact bg="bg-lawguebase" />
    </>
  )
}
